import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import PromoteFlowStep from './PromoteFlowStep'

class RoleLevelSalaryStep extends PromoteFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.promote.steps.role_level_salary.title'),
      component,
      i18n.t('contract_versions.flows.promote.steps.role_level_salary.description')
    )
  }
}

export default RoleLevelSalaryStep
